// test1862
(1862 && 0);
